// extracted by mini-css-extract-plugin
export default {"card":"Slider_card__YLcTO","label":"Slider_label__IiTLY","inputs":"Slider_inputs__QGkTO","input":"Slider_input__ZEsY1"};